import React from "react";

interface Props {}

const PlusIcon = (props: Props) => {
  return <div>+</div>;
};

export default PlusIcon;
